<template>
  <el-menu
    class="navbar"
    mode="horizontal"
  >
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown
      class="avatar-container">
      <div class="avatar-wrapper">
        <div>
          <el-button
            type="primary"
            icon="el-icon-user"
            circle
            @click.native.prevent="switchShop"
            
          ></el-button>
          <span class="shop-Name">{{shopName}}</span>
          <!-- <img
            class="user-avatar"
            :src="avatar"
          > -->
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
      <el-dropdown-menu
        class="user-dropdown"
        slot="dropdown"
      >
        <router-link
          class="inlineBlock"
          to="/"
        >
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span
            @click="switchShop"
            style="display:block;"
          >切换店铺</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span
            @click="logout"
            style="display:block;"
          >退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <audio
      controls="controls"
      :src="neworder_mp3"
      id="neworder_audio"
      hidden
      muted
    ></audio>
    <audio
      controls="controls"
      :src="appointmentOrder_ogg"
      id="appointmentOrder_audio"
      hidden
      muted
    ></audio>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { getShopName, getShopId } from "@/utils/auth.js";
import neworder_mp3 from "@/assets/mp3/neworder.mp3";
import appointmentOrder_ogg from "@/assets/mp3/appointmentOrder.ogg";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  data() {
    return {
      shopName: getShopName(),
      neworder_mp3,
      appointmentOrder_ogg
    };
  },
  created() {
    this.orderWebsocket();
  },
  methods: {
    orderWebsocket() {
      var socketUrl = process.env.BASE_API;
      socketUrl = socketUrl.replace("https", "wss").replace("http", "ws");
      var webSocket = new WebSocket(socketUrl + "/socket/print/" + getShopId());
      var that = this;
      webSocket.onopen = function(event) {
        console.log("WebSocket打开链接");
        that.$message({
          message: "已与服务端链接，"+getShopName()+" 可接受实时订单消息",
          type: "success"
        });
      };

      webSocket.onmessage = function(event) {
        //console.log(event);
        //console.log("websocket 收到消息：%c" + event.data, "color:green");
        //获取服务端消息
        var result = JSON.parse(event.data);
        if (result.code === 0) {
          //新订单提示
          that.$notify({
            title: "新订单 点击打印并跳转订单页",
            message: "订单号:" + result.order.orderSn,
            type: 'success',
            duration: 0,
            onClick: function() {
              that.$router.push({
                path: "/oms/order",
                query: {
                  status: result.order.status,
                  orderSn: result.order.orderSn
                }
              });
              this.close();
            }
          });
          var aaa = document.getElementById("neworder_audio");
          aaa.currentTime = 0; //从头开始播bai放提示du音
          aaa.play(); //播放
        }else if(result.code === 1){
          //预约单提示
          that.$notify({
            title: "预约单 点击打印并跳转订单页",
            message: "订单号:" + result.order.orderSn,
            type: 'warning',
            duration: 0,
            onClick: function() {
              that.$router.push({
                path: "/oms/order",
                query: {
                  status: result.order.status,
                  orderSn: result.order.orderSn
                }
              });
              this.close();
            }
          });
          var bbb = document.getElementById("appointmentOrder_audio");
          bbb.currentTime = 0; //从头开始播bai放提示du音
          bbb.play(); //播放
        }
      };

      webSocket.onclose = function(event) {
        that.$message({
          message: "服务端，关闭链接",
          type: "warning"
        });
        console.log("WebSocket关闭链接");
      };

      webSocket.onerror = function(event) {
        that.$message.error("与服务端链接错误，无法接受实时消息！");
        console.log("WebSocket发生异常");
      };
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    switchShop() {
      this.$router.push({ path: "/changeshop" });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 0px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
      .shop-Name{
        font-size: 20px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue